export default {
  order_center: 'Order Center',
  orinary: 'Orinary Order',
  insurance: 'Insurance Order',
  order_search: 'Order Search',
  order_status: 'Order status',
  remittance_identification_code: 'Remittance Identification Code',
  exhibition_name: 'Exhibition Name',
  booth_Name: 'Booth name',
  order_number: 'Order number',
  sdopo: 'Starting date of placing order',
  edoo: 'End date of order',
  reset: 'Reset',
  search: 'Search',
  NCOTONTVTOD: 'Note: Click on the order number to view the order details.',
  exhibition_number: 'Exhibition number',
  policy_no: 'Policy No',
  sdoip: 'Starting date of insurance policy',
  edoip: 'End date of insurance policy',
  order_amount: 'Order Amount',
  RMB: 'RMB',
  all: 'ALL',
  insured_company: 'Insured company',
  order_time: 'Order time',
  trustees: 'trustees',
  contact_number: 'Contact number',
  download: 'Download',
  remove: 'remove',
  order_details: 'Order details',
  deposit: 'deposit',
  booth_number: 'Booth Number',
  Exhibitor: 'Exhibitor',
  Person_in_charge: 'Person in charge',
  order_remark: 'remark',
  continue_payment: 'Continue payment',
  doio: 'Details of insurance orders',
  Liability_insurance: 'Exhibition Liability Insurance',
  back: 'back',
  order_information: 'Order information',
  creation_time: 'Creation time',
  Insured: 'Insured company information',
  Name_of_Insured: 'Insured company',
  Unified_Social_Credit_Code: 'Unified Social Credit Code',
  Contacts: 'Contacts',
  Postal_address: 'Postal address',
  Invoice_information: 'Invoice information',
  Application_number: 'Application number',
  Invoice_type: 'Invoice type',
  Invoice_status: 'Invoice status',
  Invoice_title: 'Invoice title',
  Customer_remark: 'Remark',
  Taxpayer_identification_number: 'Taxpayer identification number',
  e_mail: 'e-mail',
  Policy_holder: 'Policy-holder',
  insurer: 'insurer',
  PolicyHolder: 'Policy Holder',
  PolicyHolderName: 'Insurance company',
  info_order_content: 'Are your sure to remove this order? click "ok" will remove it, it cannout be undone',

  //table
  '暂无数据': 'No Data',
  '展位号': 'Booth Number',
  '保险名称': 'Insurance Name',
  '规格': 'Specifications',
  '单位': 'Unit',
  '承保方案': 'Undertaking scheme',
  '面积': 'The measure of area',
  '数量': 'Amount',
  '单价': 'Unit Price',
  '商品类型': 'Commodity types',
  '商品名称': 'Product',
  '押金': 'Deposit',
  '小计': 'Total',
  '状态': 'state',
  '保单': 'Insurance policy',
  '出单失败原因': 'Reasons for Failure of Order Making',
  '未支付': 'unpaid',
  '已支付': 'paid',
  '已提交': 'submitted',
  '待审核': 'under approval',
  '审核通过': 'verified',
  '已拒绝': 'refused',
  '已取消': 'canceled',
  '已失效': 'Failed',
  '部分支付': 'Partial payment',
  '基础版': 'Basic Edition',
  '升级版': 'Upgraded version',
  '豪华版': 'Deluxe Edition',
  '待支付': 'To be paid',
  '已退款': 'Refunded',
  '已完成': 'Completed',
  '已出保单': 'Policy issued',
  '出单失败': 'Failure to issue orders',
  '已退保': 'Withdrawal of insurance',
  '已导出': 'Exported',
  '可导出': 'Derivable',
  '已申请': 'Applied',
  '确定取消订单吗': 'Are you sure you want to cancel the order?',
  '确定删除': 'Are you sure to delete the order?The order cannot be restored after deletion.',
  '云账单提示': 'The deposit has already been paid for this order, and the order is now cancelled. A deposit refund application is required before the paid deposit can be refunded',
  '购买数量': 'number',
  '保单号': 'Odd Numbers',
  '保单下载': 'down',

  '请输入订单编号': 'Please enter the order number',
  '请输入展会名称': 'Please enter the name of the exhibition.',
  '请输入展位号': 'Please enter booth number',

  '操作': 'operation',
  '查看详情': 'details',
  //显示第1到第10条记录，总共122条记录
  '显示第': 'Display the ',
  '到第': ' to ',
  '条记录，总共': ' records,a total of ',
  '条记录': ' records',

  '支付方式': 'Payment',
  '总计': 'Total',
  '商品费用总计': 'Commodity Cost Total',
  '商品押金总计': 'Commodity Deposit Total',
  '商品明细': 'Commodity Details',
  '商品费用明细': 'Commodity Cost Details',
  '商品押金明细': 'Commodity Deposit Details',
  '取消订单': 'Cancel order',
  '下载预租清单': 'Download Pre-rent List',
  '汇款信息': 'Remittance Information',
  '汇款截止时间': 'Remittance deadline',
  '汇款账号信息': 'Remittance account information',

  '投保公司信息': 'Insurance company information',

  '开户行名称': 'Deposit bank',
  '银行账号': 'Bank account',
  '公司电话': 'Company Telephone',
  '公司注册地址': 'Company Registration Address',
  '信息': 'info',
  '押金优惠': 'Deposit discount',
  '租金优惠': 'Rent concessions',
  '保单信息已更新，点击下载': 'Policy information has been updated, click to download',
  '查询表单失败': 'Query form failed',

  '派送情况': 'Delivery situation',
  '派送时间': 'Time',
  '派送图片': 'Pictures',
  '查看图片': 'view image',

  '配送信息': 'Shipping information',






}



// WEBPACK FOOTER //
// ./src/i18n/en-us/order.js